/**
 * Enum thanh toán
 * NVTOAN2 09/07/2022
 */
export default {
  All: null,
  Paid: true,
  UnPaid: false,
};
